/* src/app/master-data/suppliers/list-suppliers/list-suppliers.component.css */
/*# sourceMappingURL=list-suppliers.component-SFTTQXNY.css.map */
